import { render } from "./StreamsManageAdvertising.vue?vue&type=template&id=533ae860"
import script from "./StreamsManageAdvertising.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageAdvertising.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManageAdvertising.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "533ae860"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('533ae860', __exports__)) {
    api.reload('533ae860', __exports__)
  }
  
  module.hot.accept("./StreamsManageAdvertising.vue?vue&type=template&id=533ae860", () => {
    api.rerender('533ae860', render)
  })

}


export default __exports__